export enum NewsFeedTypeItemFR {
	NEWS = 'NEWS',
	EMAILING = 'EMAILING',
	LIVE = 'LIVE',
	REPORTING = 'REPORTING',
	CONVOC_AG = 'CONVOC_AG',
	METEO = 'METEO',
	CONVOC_SONDAGE = 'CONVOC_SONDAGE'
}

export enum NewsFeedTypeItem {
	NEWS_TARGET = 'NEWS',
	EMAILING = 'EMAILING',
	LIVE = 'LIVE',
	REPORTING = 'REPORTING',
	ASSEMBLIES = 'CONVOC_AG',
	WEATHER = 'METEO',
	POLLS = 'CONVOC_SONDAGE'
}

export const getNewsFeedTypeItemFromFR = (e: NewsFeedTypeItemFR): NewsFeedTypeItem => {
	switch (e) {
		case NewsFeedTypeItemFR.NEWS:
			return NewsFeedTypeItem.NEWS_TARGET;
		case NewsFeedTypeItemFR.EMAILING:
			return NewsFeedTypeItem.EMAILING;
		case NewsFeedTypeItemFR.LIVE:
			return NewsFeedTypeItem.LIVE;
		case NewsFeedTypeItemFR.REPORTING:
			return NewsFeedTypeItem.REPORTING;
		case NewsFeedTypeItemFR.CONVOC_AG:
			return NewsFeedTypeItem.ASSEMBLIES;
		case NewsFeedTypeItemFR.METEO:
			return NewsFeedTypeItem.WEATHER;
		case NewsFeedTypeItemFR.CONVOC_SONDAGE:
			return NewsFeedTypeItem.POLLS;
	}
};
